import { object, string } from "yup";
import { DRIVE, FLY, STAY } from "../shared/constants.js";
import { formatDate, isLocationWithInfant } from "../shared/validation/shared-rules.js";
const CHILD_AGE_REQUIRED = "Please enter children's age";
const DATE_RANGE_ERROR = 'Please make sure the drop-off date is the same or later than the pick-up date';
const TIME_RANGE_ERROR = 'Drop-off time must be the same or later than pick-up time when both dates are the same';
const DROPOFF_LOCATION_REQUIRED = 'Please select a drop-off location';
const INVALID_DATE = 'Please select a valid date';
const INVALID_DATES = 'Please select valid dates';
const HOTEL_LOCATION_REQUIRED = 'Please enter a valid location';
const PICKUP_LOCATION_REQUIRED = 'Please select a pick-up location';
const DISALLOW_INFANT_INTL_FLIGHT = 'Sorry, we do not offer lap infant seating on international flights';
function handleInfantTravel(formState) {
    const { childrenAges, children } = this.parent;
    const { startLocation, endLocation, tripType } = formState;
    if (tripType.includes(FLY) && (isLocationWithInfant(startLocation, childrenAges) || isLocationWithInfant(endLocation, childrenAges))) return this.createError({
        message: DISALLOW_INFANT_INTL_FLIGHT,
        path: this.path
    });
    const validAgesCount = Object.values(childrenAges || {}).filter((age)=>/^\d+$/.test(String(age)) && Number(age) >= 0).length;
    if ((tripType.includes(STAY) || tripType.includes(FLY)) && validAgesCount !== children) return this.createError({
        message: CHILD_AGE_REQUIRED,
        path: this.path
    });
    return true;
}
function isWithinDateRange() {
    const { endDate, startDate } = this.parent;
    const formattedStartDate = formatDate({
        dateStr: startDate
    });
    const formattedEndDate = formatDate({
        dateStr: endDate
    });
    return new Date(formattedStartDate) <= new Date(formattedEndDate);
}
const carSearchFormSchema = object().shape({
    travelers: object().shape({
        childrenAges: object().test({
            name: 'childrenAges',
            test () {
                return handleInfantTravel.call(this, this.options.from[2].value);
            }
        })
    }),
    endDate: string().when('tripType', {
        is: (tripType)=>tripType === DRIVE,
        then: (schema)=>schema.required(INVALID_DATE).when('startDate', {
                is: (startDate)=>'' !== startDate,
                then: (nestedSchema)=>nestedSchema.test({
                        message: DATE_RANGE_ERROR,
                        name: 'endDate',
                        test: isWithinDateRange
                    }),
                otherwise: (nestedSchema)=>nestedSchema.nullable()
            }),
        otherwise: (schema)=>schema.nullable()
    }),
    endTime: string().when('tripType', {
        is: (tripType)=>tripType === DRIVE,
        then: (schema)=>schema.test({
                name: 'endTime',
                message: TIME_RANGE_ERROR,
                test () {
                    const { startDate, endDate, startTime, endTime } = this.parent;
                    if (!startDate || !endDate || startDate !== endDate) return true;
                    if (!startTime || !endTime) return true;
                    return endTime >= startTime;
                }
            }),
        otherwise: (schema)=>schema.nullable()
    }),
    endLocation: object().nullable().when('oneWay', {
        is: true,
        then: (schema)=>schema.nullable().required(DROPOFF_LOCATION_REQUIRED)
    }).when('tripType', {
        is: (tripType)=>tripType.includes(STAY),
        then: (schema)=>schema.nullable().required(HOTEL_LOCATION_REQUIRED)
    }).when('tripType', {
        is: (tripType)=>tripType.includes(FLY),
        then: (schema)=>schema.nullable().required(HOTEL_LOCATION_REQUIRED)
    }),
    hotelEndDate: string().nullable().when('tripType', {
        is: (tripType)=>tripType.includes(STAY),
        then: (schema)=>schema.required(INVALID_DATES)
    }).when('tripType', {
        is: (tripType)=>tripType.includes(FLY),
        then: (schema)=>schema.required(INVALID_DATES)
    }),
    hotelStartDate: string().nullable().when('tripType', {
        is: (tripType)=>tripType.includes(STAY),
        then: (schema)=>schema.required(INVALID_DATES)
    }).when('tripType', {
        is: (tripType)=>tripType.includes(FLY),
        then: (schema)=>schema.required(INVALID_DATES)
    }),
    startDate: string().nullable().when('tripType', {
        is: (tripType)=>tripType === DRIVE,
        then: (schema)=>schema.required(INVALID_DATE)
    }),
    startLocation: object().nullable().when('tripType', {
        is: (tripType)=>tripType === DRIVE,
        then: (schema)=>schema.nullable().required(PICKUP_LOCATION_REQUIRED)
    }).when('tripType', {
        is: (tripType)=>tripType.includes(FLY),
        then: (schema)=>schema.nullable().required(HOTEL_LOCATION_REQUIRED)
    })
});
const validation = carSearchFormSchema;
export { CHILD_AGE_REQUIRED, DROPOFF_LOCATION_REQUIRED, HOTEL_LOCATION_REQUIRED, INVALID_DATE, INVALID_DATES, PICKUP_LOCATION_REQUIRED, TIME_RANGE_ERROR, validation as default };
